import { UICommandContext } from "./UICommandContext";
import { UICommandKeyboardInput } from "./UICommandKeyboardInput";



export abstract class UICommand<Context extends UICommandContext>
{
  condition:string;
  inputCondition:string;

  keyboardInputs:UICommandKeyboardInput[] = [];
  
  get activeKeyboardInputs()
  {
    return this.keyboardInputs.filter( k => k.enabled );
  }

  abstract execute( context:Context ):void;

  

}